import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuardService {

  constructor(public router: Router, public localStorageService: AbstractLocalStorageService, public personalUserDataService: AbstractPersonalUserDataService) { }
  
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const featureId = route.data.feature as string;
    if (!this.personalUserDataService.isUserLoggedIn()) {
      return false;
    }
    
    try{
      const isFeatureAllowed = await firstValueFrom(this.personalUserDataService.verifyFeature(featureId));

      if (!isFeatureAllowed) {
        this.router.navigate([NAVIGATION_ROUTES.home], { state: { redirect: state.url } });
        return false;
      } else {
        return true;  
      }
    } catch (error) {
      console.error("Error in verification", error);
      return false; // In case of error, also prevent navigation
    }
  }
}
